import Helper from './Helper';
import NoHeader from './NoHeader';

class CategoryLoader {

  constructor() {
    this.categories = Array.prototype.slice.call(document.querySelectorAll('.category-page'));
    this.placeArticle = new Array();
    if (Array.isArray(this.categories) && this.categories.length) {
      this.readMoreLink = `
      <a class="ns-link" href="REPLACE">
        <span class="ns-link__icon">
          <svg class="icon icon-read-more" id="uuid-03ca497e-4059-4438-a480-7a484e9e2def" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17"><circle cx="8.99" cy="8.99" r="8" style="fill: #ffcc03;"/><path id="uuid-acde615b-6d7d-4e91-9481-7486ab3f50d3" data-name="Fill 4" d="m12.58,8.99l-3.89,3.6h-1.65l3.29-3.03H0v-1.15h10.33l-3.29-3.02h1.65l3.89,3.6Z" style="fill: #010202;"/></svg>
        </span>
        <span class="ns-link__text">` + this.categories[0].dataset.readMore + `</span>
      </a>`;
      let i = 0;
      this.categories.forEach(category => {
        this.loadPage(category, i);
        i++;
      });
    }
  }

  loadPage(category, iteration) {
    const restUrl = category.dataset.restUrl;
    this.getData(restUrl).then((posts) => {
      for (let i = 0; i < posts.length; i++) {
        if (i == 0) {
          this.firstPost(posts[i], category, iteration);
        } else {
          this.placePost(posts[i], category, iteration);
        }
      }
      console.log(posts);
      this.showContainer(iteration);
      new NoHeader();
    });
  }

  getData(restUrl) {
    return fetch(restUrl, {
      headers: {
       'X-WP-Token': NSContext.token
      }})
      .then((response) => {
        return response.json();
      })
  }

  firstPost(post, category, iteration) {

    const article = document.createElement('article');
    article.innerHTML = post.content.replace('ns-img', 'ns-img loaded');

    const htmlContainer = `
    <div class="category-overview category-overview--` + iteration + `">
    <section class="category-overview__articles category-overview__articles--` + iteration + `" style="opacity: 0"><div id="js-append-here-` + iteration + `" class="category-overview__lines"></div></section>
    </div>
    `;

    article.classList.add('category', 'content');
    article.innerHTML += htmlContainer;
    Helper.loadImagesInDomElement(article);
    category.appendChild(article);
    this.placeArticle[iteration] = document.querySelector('#js-append-here-' + iteration);
  }

  placePost(post, category, iteration) {
    const hasLead = !post.categories.includes(parseInt(category.dataset.noLead));
    let hasImg = !post.categories.includes(parseInt(category.dataset.noImg));
    const hasLink = !post.categories.includes(parseInt(category.dataset.noLink));

    let img;
    let link = post.seo.url;
    let lead;

    if ( !link ) {
      link = "?p=" + post.id;
    }

    const element = document.createElement('div');
    element.innerHTML = post.content;
    if (hasImg) {
        const teaserImg = element.querySelector('.ns-img__teaser');
        let url;
        if(teaserImg && teaserImg !== undefined && !teaserImg.classList.contains('doc-image-empty')){
            url = teaserImg.dataset.src;
        } else{
          const bgImg = element.querySelector('.ns-img__bg-image');
          if(bgImg && bgImg != undefined){
            let style = bgImg.getAttribute('style');
            const a = style.split('background-image: url(');
            url = a[a.length - 1];
            url = url.slice(0, -1);
          }
        }
        if(url && url != undefined && !url.includes('data:image/svg+xml;charset=UTF')){
          img = '<a href="'+ link +'" class="overview-article__img-link"><div class="overview-article__img loaded" style=\'background-image: url("'+url+'")\'></div></a>';
        } else{
          img = false;
      }
    }

    if (hasLead) {
      lead = element.querySelector('.ns-lead');

      if(!lead){
        lead = element.querySelector('.ns-paragraph');
      }
    }

    let title = element.querySelector('.ns-title-h1');

    if (!title) {
      title = element.querySelector('.ns-title-h2');
      if (!title) {
        title = element.querySelector('.ns-title-h3');
      }
    }

    if(title){
      const article = document.createElement('div');
      article.classList.add('overview-article');
      //article.href = post.link;
      if (hasImg && img && img != undefined) {
        article.innerHTML += img;
      }
      article.innerHTML += '<h2 class="overview-article__title">' + title.innerHTML + '</h2>';
      if (hasLead && lead) {
        if(hasLink){
          article.innerHTML += '<p class="overview-article__lead">' + Helper.cutString(lead.innerHTML, 300), +'</p>';
        } else{
          article.innerHTML += '<p class="overview-article__lead">' + lead.innerHTML + '</p>';
        }
      }
      if(hasLink){
        article.innerHTML += this.readMoreLink.replace('REPLACE', link);
      }

      Helper.appendInDom(this.placeArticle[iteration], article);
    }
  }

  showContainer(i) {
    const container = document.querySelector('.category-overview__articles--' + i);

    /*
    if (Helper.isTablet()) {
      container.style.height = ((container.offsetHeight / 2) + 170) + 'px';
    }

     */
    container.style.opacity = 1;
  }

}

export default CategoryLoader;
